module.exports = __webpack_public_path__ + "static/media/jumbled-words-rptr-water.45bbd9ea.svg";